import {VehicleFormType} from '../types/VehicleFormType';

/** Form field names for filter-related fields, in dependency order (earlier fields affect later options). */
export const FILTER_FORM_FIELD_NAMES: (keyof VehicleFormType)[] = [
  'make',
  'modelFamily',
  'firstRegistrationOnYear',
  'fuelType',
  'transmission',
  'drive',
  'power',
  'bodyStyle',
];

/**
 * Returns form field names that are dependent on the given field (all fields declared under it in
 * FILTER_FORM_FIELD_NAMES). Changing the given field should reset these.
 */
export function getDependentFilterFieldNames(
  changedFieldName: keyof VehicleFormType
): (keyof VehicleFormType)[] {
  const index = FILTER_FORM_FIELD_NAMES.indexOf(changedFieldName);
  if (index === -1) {
    return [];
  }
  return FILTER_FORM_FIELD_NAMES.slice(index + 1);
}
